// extracted by mini-css-extract-plugin
export default {"tablesWrapper":"BookkeepingTables_tablesWrapper__o53w1"};